/**
 * Dumb check of Safari user agent
 *
 * @returns Boolean
 */
export const isSafari = (userAgent) => {
    const localUserAgent = userAgent || navigator.userAgent;

    return localUserAgent.indexOf('Safari') !== -1 && localUserAgent.indexOf('Chrome') === -1;
};

export const isIosDevice = () => {
    const { maxTouchPoints, platform } = navigator;

    return platform && (/iP(ad|hone|od)/.test(platform) || (platform === 'MacIntel' && maxTouchPoints > 1));
};

export const isIosSafari = () => {
    const { userAgent, vendor } = navigator;

    return vendor.indexOf('Apple') > -1 && /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(userAgent);
};

/**
 * Check if browser supports IntersectionObserver
 *
 * @returns Boolean
 */
export const isIntersectionObserverSupported = () => 'IntersectionObserver' in window
    && 'IntersectionObserverEntry' in window
    // eslint-disable-next-line compat/compat
    && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

export default isSafari;
